import React, { Component } from 'react';
import { Menu, Tabs } from 'antd';
import { Row } from '../basic';
import * as MetaComponents from './index';
import Meta from '../meta-runner';
import classnames from 'classnames';
import { Table2D } from '../basic';
//FLH2D Move 2D Table To YXYWeb
const MenuItem = Menu.Item;
const TabPane = Tabs.TabPane;

export default class LineTabs extends Component {
  constructor(props) {
    super(props);
    this.keyField = 'cGroupCode';
    this.key = props.meta[this.keyField];
    this.paneStates = {};
    this.defaultActiveKey = this.init(props.meta.containers);
    if (props.config.max !== false && this.canMax || props.config.max) {
      const { viewModel } = props;
      const key = `btnMax_${this.key}`;
      this.maxButtonMeta = {
        cControlType: 'Button',
        cItemName: key,
        currentState: 'min',
        icon: 'zuidahua',
        className: 'btn-maximize',
        iconType: 'iconfont',
        iStyle: 2,
        needClear: false,
        value: '最大化',
      };
      const buttonModel = new cb.models.SimpleModel(this.maxButtonMeta);
      viewModel.addProperty(key, buttonModel);
      buttonModel.on('click', () => {
        const currentState = buttonModel.getState('currentState');
        const newState = currentState === 'min' ? 'max' : 'min';
        buttonModel.setState('currentState', newState);
        buttonModel.setState('value', newState === 'max' ? '恢复' : '最大化');
        this.maxButtonMeta.icon = newState === 'max' ? 'zuixiaohua2' : 'zuidahua';
        this.setState({ currentState: newState });
        viewModel.execute('recalcTableHeight', newState === 'max' ? 46 : 0, this.key);
      });
    }
    this.state = Object.assign({
      activeKey: this.defaultActiveKey,
      paneStates: this.paneStates
    }, props.config);
  }
  componentDidMount() {
    const { activeKey } = this.state;
    if (this.external[activeKey])
      this.handleClick(activeKey);
    const { viewModel, meta } = this.props;
    viewModel.on('updateViewMeta', args => {
      if (this.groupKeys.indexOf(args.code) === -1) return;
      if (args.caption) {
        const container = this.newContainers.find(item => {
          return item[this.keyField] === args.code;
        });
        if (container) {
          container.cName = args.caption;
          this.setState({ flag: true });
        }
        return;
      }
      const { paneStates, activeKey } = this.state;
      let newActiveKey = activeKey;
      const { code, visible, refresh, active } = args;
      if (visible != null)
        paneStates[code].visible = visible;
      paneStates[code].refresh = refresh;
      if (active && visible !== false)
        newActiveKey = code;
      const states = { paneStates };
      if (paneStates[activeKey] && paneStates[activeKey].visible === false)
        newActiveKey = this.defaultActiveKey;
      const hasActiveKey = Object.keys(paneStates).find((v) => { return paneStates[v].visible });
      if (!hasActiveKey)
        states.activeKey = '';
      else if (!activeKey)
        states.activeKey = hasActiveKey;
      // let newActiveKey = Object.keys(paneStates).find((v) => { return paneStates[v].visible }) || '';
      // if (keyVisible[activeKey] === false) {
      //   states.activeKey = this.defaultActiveKey;
      //   if (keyVisible[states.activeKey] === false)
      //     states.activeKey = '';
      // }
      // if (activeKey === '' && args.visible)
      //   states.activeKey = args.code;

      /*add by jinzh1 隐藏页签后   default页签visible为false时 重新获取visible为true的页签key*/
      if (paneStates[newActiveKey] && paneStates[newActiveKey].visible === false)
        newActiveKey = Object.keys(paneStates).find((v) => { return paneStates[v].visible }) || '';

      this.setState(states);
      if (newActiveKey !== activeKey)
        this.handleClick(newActiveKey);
    });
  }
  init(containers) {
    if (!containers || !containers.length) return;
    let activeKey = '';
    this.toolbarContainers = {};
    this.newContainers = [];
    this.groupKeys = [];
    this.external = {};
    let tableContainerCount = 0;
    containers.forEach((container, index) => {
      const key = container[this.keyField];
      if (index === 0)
        activeKey = key;
      const subContainers = container.containers;
      if (!subContainers || !subContainers.length) return;
      const newContainer = Object.assign({}, container);
      newContainer.containers = [];
      subContainers.forEach(item => {
        const containerType = item.cControlType && item.cControlType.trim().toLocaleLowerCase();
        if (containerType === 'toolbar') {
          if (this.toolbarContainers[key])
            this.toolbarContainers[key].controls = (this.toolbarContainers[key].controls || []).concat(item.controls || []);
          else
            this.toolbarContainers[key] = item;
        } else {
          newContainer.containers.push(item);
          if (containerType === 'table')
            tableContainerCount++;
          else
            tableContainerCount--;
        }
      });
      this.newContainers.push(newContainer);
      this.groupKeys.push(key);
      this.paneStates[key] = { visible: true };
      if (!container.cStyle) return;
      const config = JSON.parse(container.cStyle);
      if (!config.billnum) return;
      this.external[key] = { config: container.cStyle };
      tableContainerCount--;
    });
    if (tableContainerCount === containers.length)
      this.canMax = true;
    return activeKey;
  }
  externalReady(parentViewModel, viewModel, config) {
    if (!config.filter) return;
    const condition = { commonVOs: [{ itemName: config.filter, value1: null }] };
    let currentValue = parentViewModel.get(config.key).getValue();
    condition.commonVOs[0].value1 = currentValue;
    if (config.filters)
      for (let itemName in config.filters)
        condition.commonVOs.push({ itemName, value1: config.filters[itemName] });
    const params = viewModel.getParams();
    params.filterId = null;
    params.condition = condition;
    if (!currentValue)
      params.autoLoad = false;
    parentViewModel.on('afterLoadData', function () {
      currentValue = parentViewModel.get(config.key).getValue();
      if (!currentValue) return;
      condition.commonVOs[0].value1 = currentValue;
      viewModel.execute('filterClick', { condition });
    });
  }
  handleClick(key) {
    this.setState({ activeKey: key });
    this.props.viewModel.execute('tabActiveKeyChange', { key });
    if (!this.external[key]) return;
    if (this.external[key].viewModel) {
      const { paneStates } = this.state;
      if (paneStates[key] && paneStates[key].refresh)
        this.external[key].viewModel.execute('refresh');
      return;
    }
    const config = JSON.parse(this.external[key].config);
    const data = {
      billtype: 'voucherlist',
      billno: config.billnum
    };
    cb.loader.runCommandLine('bill', data, this.props.viewModel, (vm, viewmeta) => {
      this.externalReady(this.props.viewModel, vm, config);
      this.external[key].viewModel = vm;
      this.external[key].metaData = viewmeta;
      this.setState({ flag: true });
    });
  }
  renderMenuItems() {
    const { paneStates } = this.state;
    const menuItems = [];
    this.newContainers.forEach(item => {
      const key = item[this.keyField];
      if (paneStates[key] && paneStates[key].visible === false) return;
      menuItems.push(<MenuItem key={key}><a>{item.cName}</a></MenuItem>);
    });
    if (cb.isTest_Table2D) {
      menuItems.push(<MenuItem key={"Table2DKey"}><a>{"Table2D"}</a></MenuItem>);
    }
    return menuItems;
  }
  renderMenu() {
    const menuItems = this.renderMenuItems();
    return (
      <Menu className="tab-menu" mode="horizontal" selectedKeys={[this.state.activeKey]} onSelect={e => this.handleClick(e.key)}>
        {menuItems}
      </Menu>
    )
  }
  renderTabItems() {
    const { viewModel, width, height, extraProps } = this.props;
    const { paneStates } = this.state;
    const items = [];
    let tabContent = null;
    this.newContainers.forEach(container => {
      const key = container[this.keyField];
      if (paneStates[key] && paneStates[key].visible === false) return;
      const externalObj = this.external[key];
      tabContent = externalObj ? externalObj.viewModel && <Meta index={this.props.index} width={width} viewModel={externalObj.viewModel} metaData={externalObj.metaData} {...extraProps}/> : 
      <MetaComponents.Container meta={container} viewModel={viewModel} width={width} height={height} parents={{ type: 'LineTabs', key: this.key }} {...extraProps}/>
      items.push(<TabPane tab={container.cName} key={key} forceRender><div id={`${viewModel.getParams() && viewModel.getParams().billNo}|${key}`}>{tabContent}</div></TabPane>);
    });

    if (cb.isTest_Table2D) {
      let key = "Table2DKey";
      tabContent = <Table2D
        index={this.props.index}
        width={width}
        allProp={this.props}
        bMax={this.state.currentState === 'max'}
      />;

      items.push(<TabPane tab={"Table2D"} key={key}>
        <div id={`${viewModel.getParams() && viewModel.getParams().billNo}|${key}`}>
          {tabContent}
        </div>
      </TabPane>);
    }

    return items;
  }
  renderToolbar() {
    let toolbarContainer = this.toolbarContainers[this.state.activeKey];
    if (!toolbarContainer)
      toolbarContainer = { controls: [] };
    if (!toolbarContainer.controls)
      toolbarContainer.controls = [];
    const controls = [].concat(toolbarContainer.controls);
    if (this.maxButtonMeta)
      controls.push(this.maxButtonMeta);
    return (
      <div className='tab-top-right'>
        <MetaComponents.Toolbar align={'right'} config={toolbarContainer.cStyle} controls={controls} model={this.props.viewModel} />
      </div>
    );
  }
  render() {
    const { activeKey, classname } = this.state;
    if (!activeKey)
      return null;
    const menu = (
      <Row>
        {this.renderMenu()}
        {this.renderToolbar()}
      </Row>
    );
    const tabs = (
      <Tabs className="card-container" activeKey={activeKey} type="card" animated={false}>
        {this.renderTabItems()}
      </Tabs>
    );
    return (
      <Row className={classnames('line-tabs', classname, { 'line-tabs-maximize': this.state.currentState === 'max' })}>
        {menu}
        {tabs}
      </Row>
    );
  }
}



// WEBPACK FOOTER //
// ./src/yxyweb/common/components/meta/LineTabs.jsx